/**
 * Creates a colored version of the competitor marker SVG by replacing 'currentColor'
 */
export function createColoredMarkerSvg(baseSvg: string, color: string): string {
  return baseSvg.replace(/currentColor/g, color);
}
